/* eslint-disable @angular-eslint/directive-selector */
import { Directive } from '@angular/core';

@Directive({
  selector: 'ntt-label',
})
export class NttLabel {}
